import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import gql from 'graphql-tag';
import { BusinessAreasListQuery } from '../gql-types.generated';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const QUERY_BUSINESS_AREAS_LIST = gql`
    query businessAreasList {
        businessAreas {
            nodes {
                name
                description
                id
            }
        }
    }
`;

export const queryBusinessAreaList = async (client: ApolloClient<NormalizedCacheObject>) => {
    
    const { data, errors } = await client.query<BusinessAreasListQuery>({
        query: QUERY_BUSINESS_AREAS_LIST,
    });

    if (errors && errors.length > 0) {
        errors.forEach(error => {
            // Log error details in the console.
            console.error(error);
        });
        // Friendly error to the user.
        throw new Error('An error has occurred during the query.');
    }

    return data?.businessAreas?.nodes;
};